<template>
 <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <LmBreadcrumb v-if="showBreadcrumb" />
    <LmForm ref="lmFormRef">
        <div class="row">
            <LmTextInput
                class="col-12"
                v-model="form.title"
                label="Título"
                :v="$v.form.title"
                />
        </div>
        <div class="row">
            <LmEditor
                ref="lmEditorSeccionVisto"
                class="col-12"
                @onUpdate="form.content = $event"
                label="Contenido"
                :v="$v.form.content"
                :contentProps="form.content"
                :activeTable="false"
            />
        </div>

         <LmImagenPages v-model="options" v-show="options.image" @fileRemoved="fileRemoved" class="my-2 mb-4" />

        <LmUploadFiles
            label="Imagen de la tabla"
            ref="lmUploadFiles"
            class="mb-3"
            :dropzoneOptions="dropzoneOptions"
            dictDefaultMessage='Arrastre la imagen acá para subirla'
            :v="$v.form.image_url"
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileCreated"
            v-show="!options.image"
        />

        <LmButton
        id="btn-cancel"
        type="button"
        buttonClass="btn-secondary"
        :isProcessing="formIsProcessing"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        />

        <LmButton
            type="submit"
            buttonClass="btn-success"
            :isProcessing="formIsProcessing"
            :value="$t('Save')"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            @click.native="submit('guardar')"
        />

        <LmButton
            type="submit"
            buttonClass="btn-primary"
            :isProcessing="formIsProcessing"
            :value="$t('Guardar y salir')"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            @click.native="submit('guardarSalir')"
        />

    </LmForm>

 </div>
</template>

<script>
import store from '@/store'
import axios from 'axios'

import LmForm from '@/components/form/LmForm.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import { required } from 'vuelidate/lib/validators'
import LmEditor from '@/components/LmEditor.vue'
import LmButton from '@/components/form/elements/LmButton.vue'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmImagenPages from '@/views/365/pages/elements/LmImagenPages'

export default {
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      form: {
        title: '',
        content: '',
        image_url: ''
      },
      formIsProcessing: false,
      files: [],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}documentos/nuevo/`,
        headers: {
          'Cache-Control': null,
          'X-Requested-With': null,
          Authorization: `Bearer ${store.state.session.accessToken}`
        },
        withCredentials: true,
        thumbnailWidth: 150,
        maxFiles: 1,
        addRemoveLinks: true,
        acceptedFiles: 'image/*'
      },
      options: {
        type: Object,
        idRandom: '',
        id: '',
        title: '',
        image: '',
        imageOriginalName: '',
        imageSize: '',
        default: () => ({
          disabledOption: 'Seleccione una acción',
          content: []
        })
      }
    }
  },
  validations: {
    form: {
      title: {
        required
      },
      content: {
        required
      },
      image_url: {
        required
      }
    }
  },
  components: {
    LmForm,
    LmTextInput,
    LmEditor,
    LmButton,
    LmUploadFiles,
    LmImagenPages
  },
  methods: {
    async submit (guardarType) {
      try {
        await this.$refs.lmFormRef.validationForm(this.$v)
        this.formIsProcessing = true
        const fileLoaded = this.files.length ? this.files[0].path : ''
        const dataToSendToTheServer = {
          title: this.form.title,
          content: this.form.content,
          urlimagen: fileLoaded || this.form.image_url
        }

        await axios.post(
          `${process.env.VUE_APP_API_URL}pages/edit-precios-vigentes/`,
          dataToSendToTheServer,
          {
            headers: {
              Authorization: `Bearer ${store.state.session.accessToken}`
            }
          }
        )

        if (guardarType === 'guardarSalir') {
          this.$router.go(-1)
        } else {
          this.makeToast('guardar')
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.formIsProcessing = false
      }
    },
    makeToast (variant = null) {
      if (variant === 'guardar') {
        this.$bvToast.toast('El contenido se guardó exitosamente.', {
          title: `Mensaje`,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
    },
    cancelBtn () {
      this.$router.go(-1)
    },
    fileCreatedd (file, response) {
      if (response) {
        this.form.image_url = response.path
        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileCreated (file, response) {
      if (response) {
        setTimeout(() => {
          this.options.idRandom = Math.random()
        }, 1000
        )
        this.form.image_url = response.path
        this.options.image = response.path
        this.options.imageOriginalName = response.originalname
        this.options.imageSize = this.bytesToSize(response.size)

        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileRemovedd (file, error, xhr) {
      this.form.image_url = ''
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.enable()
    },
    fileRemoved (file, error, xhr) {
      this.form.image_url = ''
      this.options.image = ''
      this.files = []
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.lmRemoveAllFiles()
      this.$refs.lmUploadFiles.enable()
    },
    bytesToSize (bytes) {
      const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    },
    async setForm () {
      await this.$refs.lmFormRef.activeEditMode({
        path: 'pages/read-precios-vigentes/'
      })
      if (this.form.image_url) {
        const fileOption = {
          size: 100000
        }
        this.$refs.lmUploadFiles.lmManuallyAddFile(fileOption, this.form.apiUrlPath + this.form.image_url)
        this.options.image = this.form.image_url
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    }

  },
  mounted () {
    this.setForm()
  }
}

</script>

<style>

</style>
